/* launch.icon.svg.js */

module.exports = {
    icon: `
        <svg viewBox="0 0 17.5 17.7" preserveAspectRatio="none">
            <path fill="#ccc" class="foreground-gl" d="M17.4,8.4L17.3,9c-0.2,1.1-0.6,1.5-1.8,1.5h-5l-0.9,5.7c-0.2,1.1-0.7,1.5-1.9,1.5H7c-1.2,0-1.6-0.4-1.4-1.5 l0.9-5.7h-5c-1.2,0-1.7-0.3-1.5-1.5l0.1-0.6c0.2-1.2,0.7-1.5,1.9-1.5h5l0.9-5.4C8.1,0.3,8.6,0,9.8,0h0.7c1.2,0,1.6,0.3,1.4,1.5 L11,6.9h5C17.3,6.9,17.6,7.2,17.4,8.4z"></path> 
        </svg>
    `,
};
